export default {"src":"/_next/static/media/HBAN.860ab376.svg","height":18,"width":18};